export const BODY_COLLAPSE_THRESHOLD = 120;
const COMPACT_COLLAPSE_THRESHOLD = 160;

export const shouldCollapseEmailBody = (
  body: string,
  bodyHtml: string | undefined,
  compact: boolean
): boolean =>
  (bodyHtml || body).length >
  (compact ? COMPACT_COLLAPSE_THRESHOLD : BODY_COLLAPSE_THRESHOLD);
